export type Entries<T> = NonNullable<
    {
        [K in keyof T]: [K, T[K]];
    }[keyof T]
>[];

// type safe entries function
// "any" is required here to have a correct type inference
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function entries<T extends Record<string, any>>(object: T) {
    return Object.entries(object) as Entries<T>;
}
